import React, {FC, memo, useEffect, useState} from "react";
import {Dropdown, NavDropdown} from "react-bootstrap";
import {Outlet, useNavigate} from "react-router-dom";
import NavButton from "../../component/navButton/NavButton";
import MainLabel from "../../component/mainLabel/MainLabel";

import cameraIcon from "../../image/camera.png"
import fileIcon from "../../image/files.png"
import homeIcon from "../../image/home.png"
import {BoxArrowRight, List, PersonFill} from "react-bootstrap-icons";
import {Container, HeaderContainer, NavContainer} from "./HeaderStyle";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../store/configureStore";
import HeaderMenuItem from "../../component/headerMenuItem/HeaderMenuItem";
import {DropdownItem, DropdownMenu, DropdownToggle} from "../../component/headerMenuItem/HeaderMenuItemStyle";
import {actions, IToken} from "../../store/sliceToken";
import {config} from "../../config";
import {fetchUser} from "../../fetch/AuthRequest";

const PublicHeader: FC = () => {
    return (
        <Container as={"main"}>
            <HeaderContainer>
                <MainLabel/>
            </HeaderContainer>
            <Outlet/>
        </Container>
    )
}

export default memo(PublicHeader)
